/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_NextInputs */

const id_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berikutnya`)
};

const ms_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seterusnya`)
};

const da_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Næste`)
};

const de_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächste`)
};

const en_us2_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

const es_es2_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente`)
};

const es_mx2_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente`)
};

const fil_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Susunod`)
};

const fr_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivant`)
};

const it_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Successivo`)
};

const hu_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Következő`)
};

const nl_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volgende`)
};

const no_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neste`)
};

const pl_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Następna`)
};

const pt_br2_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

const pt_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguinte`)
};

const ro_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Următor`)
};

const fi_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuraava`)
};

const sv_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nästa`)
};

const vi_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiếp`)
};

const tr_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonraki`)
};

const cs_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Další`)
};

const bg_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Следващ`)
};

const ru_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Далее`)
};

const uk_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Далі`)
};

const ar_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التالي`)
};

const hi_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगला`)
};

const th_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ถัดไป`)
};

const ja_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次へ`)
};

const zh_cn2_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

const zh_hant1_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

const ko_forms_review_next = /** @type {(inputs: Forms_Review_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

/**
* | output |
* | --- |
* | "Next" |
*
* @param {Forms_Review_NextInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_next = /** @type {((inputs?: Forms_Review_NextInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_NextInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_next(inputs)
	if (locale === "ms") return ms_forms_review_next(inputs)
	if (locale === "da") return da_forms_review_next(inputs)
	if (locale === "de") return de_forms_review_next(inputs)
	if (locale === "en-US") return en_us2_forms_review_next(inputs)
	if (locale === "es-ES") return es_es2_forms_review_next(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_next(inputs)
	if (locale === "fil") return fil_forms_review_next(inputs)
	if (locale === "fr") return fr_forms_review_next(inputs)
	if (locale === "it") return it_forms_review_next(inputs)
	if (locale === "hu") return hu_forms_review_next(inputs)
	if (locale === "nl") return nl_forms_review_next(inputs)
	if (locale === "no") return no_forms_review_next(inputs)
	if (locale === "pl") return pl_forms_review_next(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_next(inputs)
	if (locale === "pt") return pt_forms_review_next(inputs)
	if (locale === "ro") return ro_forms_review_next(inputs)
	if (locale === "fi") return fi_forms_review_next(inputs)
	if (locale === "sv") return sv_forms_review_next(inputs)
	if (locale === "vi") return vi_forms_review_next(inputs)
	if (locale === "tr") return tr_forms_review_next(inputs)
	if (locale === "cs") return cs_forms_review_next(inputs)
	if (locale === "bg") return bg_forms_review_next(inputs)
	if (locale === "ru") return ru_forms_review_next(inputs)
	if (locale === "uk") return uk_forms_review_next(inputs)
	if (locale === "ar") return ar_forms_review_next(inputs)
	if (locale === "hi") return hi_forms_review_next(inputs)
	if (locale === "th") return th_forms_review_next(inputs)
	if (locale === "ja") return ja_forms_review_next(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_next(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_next(inputs)
	return ko_forms_review_next(inputs)
});
export { forms_review_next as "forms.review.next" }